module.exports = __webpack_public_path__ + "static/media/sc.75e10e53.webp";